import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Attachment } from '../models';

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    private readonly apiUrl = 'api/attachment';

    constructor(
        private readonly httpClient: HttpClient
    ) { }

    uploadPCIComplianceDocument(formData: FormData): Observable<Attachment> {
        return this.httpClient.post<Attachment>(`${this.apiUrl}/upload/ComplianceValidation`, formData);
    }

    downloadPCIComplianceDocument(attachment: Attachment): Observable<HttpEvent<Blob>>  {
        return this.httpClient.request(new HttpRequest(
            'POST',
            `${this.apiUrl}/download/ComplianceValidation`,
            attachment,
            {
                reportProgress: true,
                responseType: 'blob'
            }));
    }
}